export const selectSelectedTopic = (state) => state.selectedTopic;
export const selectContactPage = (state) => state.selectedContactPage;
